import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=6a7a8ad4&scoped=true"
import script from "./FileThumbnail.vue?vue&type=script&lang=js"
export * from "./FileThumbnail.vue?vue&type=script&lang=js"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=6a7a8ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7a8ad4",
  null
  
)

export default component.exports